/* eslint-disable */
export default {
    activeProductContent(){
        const $seeMore = $('.see-more-content');
        const $closeMore = $('.close-content');

        $seeMore.click(function() {
            $(this).parent().parent().find('.slide-up-content').addClass('active');
        });

        $closeMore.click(function() {
            $(this).parent().removeClass('active')
        });
    },

    breadcrumbsMod() {
        const breadcrumbs = $('.breadcrumbs .post-products-archive');
        const oldUrl = breadcrumbs.attr('href');
        const newUrl = oldUrl.replace('produkt', 'produkty');
        breadcrumbs.attr('href', newUrl);
    },

    init() {
        this.activeProductContent();
        this.breadcrumbsMod();
    },

    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/tax-product_category.js